const translations = {
  en: {
    withdrawUsing: 'Withdraw using',
    amount: 'Amount',
    payoutLimits: 'PayoutLimits  Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    accountPlaceholder: 'Account',
    transactionIdPlaceholder: 'TransactionID',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    email: 'Email',
    city: 'City',
    zipCode: 'Zip Code',
    address: 'Address',
    address2: 'Address 2',
    notes: 'Notes',
    back: 'BACK',
    submit: 'SUBMIT',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    payoutStatus: 'Payout Status',
    withdrawalStatus: 'Withdrawal Status',
    amountNotPermitted: 'amount not permitted, please check your withdrawal balance',
    errorGettingCustomerInfo: 'Error getting customer info: ',
  },
  es: {
    withdrawUsing: 'Retirar usando',
    amount: 'Monto',
    payoutLimits: 'Límites de retiro  Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    accountPlaceholder: 'Cuenta',
    transactionIdPlaceholder: 'ID de Transacción',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phone: 'Teléfono',
    email: 'Correo Electrónico',
    city: 'Ciudad',
    zipCode: 'Código Postal',
    address: 'Dirección',
    address2: 'Dirección 2',
    notes: 'Notas',
    back: 'ATRÁS',
    submit: 'ENVIAR',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    payoutStatus: 'Estado del Retiro',
    withdrawalStatus: 'Estado del Retiro',
    amountNotPermitted: 'Monto no permitido, por favor verifique su saldo disponible para retiro',
    errorGettingCustomerInfo: 'Error al obtener información del cliente: ',
  },
  pt: {
    withdrawUsing: 'Sacar usando',
    amount: 'Valor',
    payoutLimits: 'Limites de saque  Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    accountPlaceholder: 'Conta',
    transactionIdPlaceholder: 'ID da Transação',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    phone: 'Telefone',
    email: 'E-mail',
    city: 'Cidade',
    zipCode: 'CEP',
    address: 'Endereço',
    address2: 'Endereço 2',
    notes: 'Notas',
    back: 'VOLTAR',
    submit: 'ENVIAR',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    payoutStatus: 'Status do Saque',
    withdrawalStatus: 'Status do Saque',
    amountNotPermitted: 'Valor não permitido, por favor verifique seu saldo disponível para saque',
    errorGettingCustomerInfo: 'Erro ao obter informações do cliente: ',
  },
}

export default translations
